import { useCapital } from "@/context/CapitalContext";
import { SearchableSelect } from "@/components/common/SearchableSelect";
import { Building2 } from "lucide-react";
import { TID } from "@/constants/testIds";

export function ClientSelector() {
  const { clients, client, setClient, loading } = useCapital();
  if (loading) {
    return <div className="w-64 h-9 shimmer rounded-md" />;
  }
  return (
    <div className="flex items-center gap-2">
      <Building2 className="w-4 h-4 text-slate-400" />
      <SearchableSelect
        value={client || ""}
        onChange={setClient}
        options={clients.map((c) => ({ value: c.name, label: c.name, meta: c.asset_count }))}
        placeholder="Select client"
        width="w-[280px]"
        testid={TID.capitalClientSelect}
      />
    </div>
  );
}
